import { Colors } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.button `
  display: grid;

  grid-auto-flow: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  border: 1px dashed ${Colors.GS500};

  padding: 16px;

  &:hover {
    background-color: ${Colors.GS200};
  }
`;
